import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PickupDropService from "../../services/pickupdrop.service";

// Fetch Airport Car Charges
export const getpickupdropChargesList = createAsyncThunk(
  "pickupdropCharges/getpickupdropChargesList",
  async (item, thunkApi) => {
    try {
      const response = await PickupDropService.getpickupdropCharges(item);
      return response.data; // Returning the actual response data
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Add Airport Car Charges
export const postpickupdropCharges = createAsyncThunk(
  "pickupdropCharges/postpickupdropCharges",
  async (item, thunkAPI) => {
    try {
      const response = await PickupDropService.addpickupdropCharges(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Update Airport Car Charges
export const putpickupdropCharges = createAsyncThunk(
  "pickupdropCharges/putpickupdropCharges",
  async (item, thunkAPI) => {
    try {
      const response = await PickupDropService.editpickupdropCharges(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Delete Airport Car Charges
export const deletepickupdropCharges = createAsyncThunk(
  "pickupdropCharges/deletepickupdropCharges",
  async (id, thunkAPI) => {
    try {
      const response = await PickupDropService.deletepickupdropCharges(id);
      return id; // Return the ID of the deleted record
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  pickupdropCharges: [], // This should be consistent in all reducers
};

const pickupdropChargesSlice = createSlice({
  name: "pickupdropCharges",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // **Handle Fetch**
      .addCase(getpickupdropChargesList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getpickupdropChargesList.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
        state.pickupdropCharges = action.payload || []; // ✅ Correctly storing API response
      })
      .addCase(getpickupdropChargesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch data";
      })

      // **Handle Add**
      .addCase(postpickupdropCharges.pending, (state) => {
        state.loading = true;
      })
      .addCase(postpickupdropCharges.fulfilled, (state, action) => {
        state.loading = false;
        state.pickupdropCharges.push(action.payload); // ✅ Add new entry to the list
      })
      .addCase(postpickupdropCharges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Update**
      .addCase(putpickupdropCharges.pending, (state) => {
        state.loading = true;
      })
      .addCase(putpickupdropCharges.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.pickupdropCharges.findIndex(
          (charge) => charge.id === action.payload.id
        );
        if (index !== -1) {
          state.pickupdropCharges[index] = action.payload; // ✅ Update existing record
        }
      })
      .addCase(putpickupdropCharges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete**
      .addCase(deletepickupdropCharges.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletepickupdropCharges.fulfilled, (state, action) => {
        state.loading = false;
        state.pickupdropCharges = state.pickupdropCharges.filter(
          (charge) => charge.id !== action.payload
        ); // ✅ Remove from state
      })
      .addCase(deletepickupdropCharges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default pickupdropChargesSlice.reducer;
